import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import OptionsContext from '../contexts/options';
import { route } from "../routes";
import {
  withRouter,
  Form,
  FormHeader,
  FormGroup,
  FormLabel,
  Textfield,
  Button,
  Fieldset,
  Checkbox,
  Radio
} from "cw-styleguide-react";

class FilterForm extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.toggleWelshLanguageRequirements = this.toggleWelshLanguageRequirements.bind(this);
  }

  componentDidMount() {
    if (
      typeof window.initialiseFormElementsGeneral === 'function' &&
      typeof window.initialiseFormElementGroups === 'function' &&
      typeof window.initialiseFormElementCollapses === 'function' &&
      typeof window.initialiseRequiredFields === 'function'
    ) {
      window.initialiseFormElementsGeneral();
      window.initialiseFormElementGroups();
      window.initialiseFormElementCollapses();
      window.initialiseRequiredFields(
        this.props.t('styleguide:field_is_required'),
        this.props.t('styleguide:choice_is_required'),
        this.props.t('styleguide:choice_is_required')
      );
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    const parameters = this.props.convertFiltersToParameters(this.props.filters);

    this.props.setQuery(parameters);
    this.props.navigate(route('results') + parameters);
  }

  handleReset() {
    this.props.resetFilters();
    this.props.resetQuery();

    this.props.navigate(route('results'));
  }

  toggleWelshLanguageRequirements(e) {
    if (e.target.checked) {
      let requirements = this.props.filters.welsh.filter(r => r !== '3');
      requirements.push(e.target.value);
      this.props.setFilter('welsh', requirements);
    }
    else {
      this.props.removeFilter('welsh', e.target.value);
    }
  }

  render() {
    let filtersApplied = 0;
    filtersApplied += this.props.filters.sector.length;
    if (this.props.filters.hours) { filtersApplied++ }
    filtersApplied += this.props.filters.level.length;
    filtersApplied += this.props.filters.welsh.length;
    if (this.props.filters.disability) { filtersApplied++ }

    return (
      <OptionsContext.Consumer>
        {({ sectors, apprenticeshipLevels, proximity, welshLanguage, hours, disabilityConfident }) => (
          <Form theme={['sidebar']} classes={['sidebar--can-collapse']}>
            <FormHeader title={this.props.t('misc.updateSearch')} loading={this.props.isLoadingApprenticeships}>
              <Button type={'submit'} icon={{ type: 'chevron-right', position: 'right' }} onClick={this.handleSubmit}>
                {this.props.t('misc.search')}
              </Button>
              <input type={'reset'} value={this.props.t('misc.clear')} onClick={this.handleReset} />
              <Button type={'button'}
                classes={['form__sidebar-toggle', 'js-form-sidebar-toggle button', 'button--style-sidebar-toggle']}>
                {this.props.t('misc.showHideFilters')}
              </Button>
              <p className="form__description">
                {this.props.t('misc.availableFilters')}
              </p>
              {this.props.isMobile && filtersApplied > 0 &&
                <p>({filtersApplied}) {this.props.t('misc.applied')}</p>
              }
            </FormHeader>
            <div className="form__body">

              {/*Keyword*/}
              <FormGroup type={'textfield'}>
                <FormLabel for={'keyword'}>
                  {this.props.t('filters.keyword.label')}
                </FormLabel>
                <Textfield id={'keyword'} name={'keyword'} value={this.props.filters.keyword}
                  classes={['suffix--is-clear-button']}
                  onChange={(e) => this.props.setFilter('keyword', e.target.value)}
                  suffix={<Button type={'button'} classes={['button--style-input-clear', 'js-clear-input']}
                    onClick={() => { this.props.setFilter('keyword', '') }}>Clear input</Button>} />
              </FormGroup>

              {/*Sector*/}
              <FormGroup type={'checkbox'}>
                <Fieldset label={this.props.t('filters.sector.label')} grouped={true} scrollable={true}>
                  <Button type={'button'} classes={['group__elements-toggle', 'js-group-elements-toggle']}>
                    {this.props.filters.sector.length > 0
                      ? <span>({this.props.filters.sector.length}) {this.props.t('misc.filtersApplied')}</span>
                      : <span>{this.props.t('misc.all')}</span>
                    }
                  </Button>
                  <Checkbox name={'sector'} label={this.props.t('misc.all')} value={'all'} checked={this.props.filters.sector.length === 0}
                    onChange={() => { this.props.setFilter('sector', []) }} />
                  {sectors.map((option, index) => {
                    return (
                      <Checkbox key={index} name={'sector'} label={option.label} value={option.value}
                        checked={this.props.filters.sector.includes(option.value)}
                        onChange={(e) => { e.target.checked ? this.props.addFilter('sector', e.target.value) : this.props.removeFilter('sector', e.target.value) }} />
                    );
                  })}
                </Fieldset>
              </FormGroup>

              {/*Location*/}
              <FormGroup type={'textfield'}>
                <FormLabel for={'location'}>
                  {this.props.t('filters.location.label')}
                </FormLabel>
                <Textfield id={'location'} name={'location'} value={this.props.filters.location}
                  classes={['suffix--is-clear-button']}
                  onChange={(e) => this.props.setFilter('location', e.target.value)}
                  suffix={<Button type={'button'} classes={['button--style-input-clear', 'js-clear-input']}
                    onClick={() => { this.props.setFilter('location', '') }}>Clear input</Button>} />
              </FormGroup>

              {/*Proximity*/}
              <FormGroup type={'radios'}>
                <Fieldset label={this.props.t('filters.proximity.label.short')} grouped={true}>
                  <Button type={'button'} classes={['group__elements-toggle', 'js-group-elements-toggle']}>
                    {proximity.find(p => p.value === this.props.filters.proximity) &&
                      <span>{proximity.find(p => p.value === this.props.filters.proximity).label}</span>
                    }
                  </Button>
                  {proximity.map((option, index) => {
                    return (
                      <Radio key={index} name={'proximity'} label={option.label} value={option.value}
                        checked={this.props.filters.proximity === option.value}
                        onChange={(e) => this.props.setFilter('proximity', e.target.value)} />
                    );
                  })}
                </Fieldset>
              </FormGroup>

              {/*Hours*/}
              <FormGroup type={'radios'}>
                <Fieldset label={this.props.t('filters.hours.label')} grouped={true}>
                  <Button type={'button'} classes={['group__elements-toggle', 'js-group-elements-toggle']}>
                    {hours.find(h => h.value === this.props.filters.hours)
                      ? <span>{hours.find(h => h.value === this.props.filters.hours).label}</span>
                      : <span>{this.props.t('misc.all')}</span>
                    }
                  </Button>
                  <Radio name={'hours'} label={this.props.t('misc.all')} value={'all'} checked={this.props.filters.hours === ''}
                    onChange={() => this.props.setFilter('hours', '')} />
                  {hours.map((option, index) => {
                    return (
                      <Radio key={index} name={'hours'} label={option.label} value={option.value}
                        checked={this.props.filters.hours === option.value}
                        onChange={(e) => this.props.setFilter('hours', e.target.value)} />
                    );
                  })}
                </Fieldset>
              </FormGroup>

              {/*Apprenticeship Level*/}
              <FormGroup type={'checkbox'}>
                <Fieldset label={this.props.t('filters.level.label')} grouped={true}
                  advancedDescription={{
                    link: { text: this.props.t('filters.level.help.label') },
                    body: <div dangerouslySetInnerHTML={{ __html: this.props.t('filters.level.help.text.long') }} />
                  }}>
                  <Button type={'button'} classes={['group__elements-toggle', 'js-group-elements-toggle']}>
                    {this.props.filters.level.length > 0
                      ? <span>({this.props.filters.level.length}) {this.props.t('misc.filtersApplied')}</span>
                      : <span>{this.props.t('misc.all')}</span>
                    }
                  </Button>
                  <Checkbox name={'level'} label={this.props.t('misc.all')} value={'all'} checked={this.props.filters.level.length === 0}
                    onChange={() => { this.props.setFilter('level', []) }} />
                  {apprenticeshipLevels.map((option, index) => {
                    return (
                      <Checkbox key={index} name={'level'} label={option.label} value={option.value}
                        checked={this.props.filters.level.includes(option.value)}
                        onChange={(e) => { e.target.checked ? this.props.addFilter('level', e.target.value) : this.props.removeFilter('level', e.target.value) }} />
                    );
                  })}
                </Fieldset>
              </FormGroup>

              {/*Welsh*/}
              <FormGroup type={'checkbox'}>
                <Fieldset label={this.props.t('filters.welsh.label')} grouped={true}>
                  <Button type={'button'} classes={['group__elements-toggle', 'js-group-elements-toggle']}>
                    {this.props.filters.welsh.length > 0
                      ? <span>({this.props.filters.welsh.length}) {this.props.t('misc.filtersApplied')}</span>
                      : <span>{this.props.t('misc.none')}</span>
                    }
                  </Button>
                  {welshLanguage.map((option, index) => {
                    return (
                      <Checkbox key={index} name={'welsh'} label={option.label} value={option.value}
                        checked={this.props.filters.welsh.includes(option.value)}
                        onChange={this.toggleWelshLanguageRequirements} />
                    );
                  })}
                </Fieldset>
              </FormGroup>

              {/*Disability*/}
              <FormGroup type={'checkbox'}>
                <Fieldset label={this.props.t('filters.disability.label')} grouped={true}>
                  <Button type={'button'} classes={['group__elements-toggle', 'js-group-elements-toggle']}>
                    {this.props.filters.disability.length > 0
                      ? <span>({this.props.filters.disability.length}) {this.props.t('misc.filtersApplied')}</span>
                      : <span>{this.props.t('misc.none')}</span>
                    }
                  </Button>
                  {disabilityConfident.length > 0 &&
                    <Checkbox name={'disability'} label={disabilityConfident[0].label} value={disabilityConfident[0].value}
                      checked={this.props.filters.disability.includes(disabilityConfident[0].value)}
                      onChange={(e) => { e.target.checked ? this.props.addFilter('disability', e.target.value) : this.props.removeFilter('disability', e.target.value) }} />
                  }
                </Fieldset>
              </FormGroup>

              {/*Vacancy ID*/}
              <FormGroup type={'textfield'}>
                <FormLabel for={'vacancyId'}>
                  {this.props.t('filters.vacancyId.label')}
                </FormLabel>
                <Textfield id={'vacancyId'} name={'kevacancyIdyword'} value={this.props.filters.vacancyId}
                  classes={['suffix--is-clear-button']}
                  onChange={(e) => this.props.setFilter('vacancyId', e.target.value)}
                  suffix={<Button type={'button'} classes={['button--style-input-clear', 'js-clear-input']}
                    onClick={() => { this.props.setFilter('vacancyId', '') }}>Clear input</Button>} />
              </FormGroup>

              <Button type={'submit'} icon={{ type: 'chevron-right', position: 'right' }} onClick={this.handleSubmit}>
                {this.props.t('misc.search')}
              </Button>
              <input type={'reset'} value={this.props.t('misc.clear')} onClick={this.handleReset} />
            </div>
          </Form>
        )}
      </OptionsContext.Consumer>
    );
  }
}

export default withRouter(withTranslation('local')(FilterForm));
